import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Folder.css';
import './SildeCopy.css';
import { Col, Row, Table, Input, Card, Tooltip } from 'antd';
import {
    RiArrowLeftLine,
    RiSearch2Line,
    RiFolderFill,
    RiBillLine,
} from 'react-icons/ri';
import CopySave from './CopySave/CopySave';
import { SlLock } from 'react-icons/sl';
import { QuickActionFolderListHandler } from '../../../../Redux/Actions/user/QuickFolderListAction';
import { QuickActionFolderHandler } from '../../../../Redux/Actions/user/QuickFolderAction';
const Folder = ({ onOpenFolder, folder_id, folder_name }) => {
    const BookMark = '/assets/bookmark.svg';
    const lock_icon = '/assets/key-square.svg';
    const [selectedCopyItem, setSelectedCopyItem] = useState({});
    const [isStandardOpen, setIsStandardOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [isFolderName, setFolderName] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [sortedInfo, setSortedInfo] = useState(null);
    const [folderid, setFolderId] = useState('');

    let dispatch = useDispatch();
    const quickactionfolder = useSelector(
        (state) => state?.Quick_Action_Folder_Data?.quick_action_folder_data
    );

    const quickactionfolderlistdata = useSelector(
        (state) =>
            state?.Quick_Action_Folder_List_Data?.quick_action_folder_list_data
                ?.data
    );
    const handlesearch = (e) => {
        let value = e.target.value.trim();
        if (value?.length) {
            setSearchValue(value);
        }

        if (value.length > 0) {
            setSearchValue(value);
            dispatch(
                QuickActionFolderListHandler(folder_id, value, currentPage)
            );
        } else {
            setSearchValue('');
            dispatch(QuickActionFolderListHandler(folder_id, '', currentPage));
        }
    };
    const handleFolderButtonClick = () => {
        onOpenFolder();
    };

    const extractContent = (html) => {
        var span = document.createElement('span');
        span.innerHTML = html;
        return span.textContent || span.innerText || '';
    };

    const handleFolderClick = (id, folderName) => {
        setCurrentPage(1);
        setFolderId(id);
        dispatch(QuickActionFolderHandler('', id));
        // dispatch(QuickActionFolderHandler("", id));
        dispatch(QuickActionFolderListHandler(id, searchValue, 1));
        setFolderName(folderName);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        // dispatch(
        //   SettingsUserAnalyticsActionHandler('','',setusageanalytics,page)
        // );
        dispatch(QuickActionFolderListHandler(folder_id, searchValue, page));
    };
    const StandardOverlay = (item) => {
        setSelectedCopyItem(item);
        setIsStandardOpen(!isStandardOpen);
    };
    useEffect(() => {
        dispatch(QuickActionFolderListHandler(folder_id, '', currentPage));
        dispatch(QuickActionFolderHandler('', folder_id));
        setFolderName(folder_name);
    }, [folder_id, currentPage]);

    const columns = [
        {
            title: 'Sr.',
            dataIndex: 'id',
            key: 'id',
            sorter: (a, b) => a.id.localeCompare(b.id),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            render: (description) => (
                <span>
                    {extractContent(description).length > 40
                        ? extractContent(description).substring(0, 40) + '.....'
                        : extractContent(description)}
                </span>
            ),
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'x',
            render: (item) => (
                <span
                    className='folder-copy-save'
                    onClick={() => StandardOverlay(item)}>
                    Copy and Save
                </span>
            ),
        },
    ];

    return (
        <>
            <div className='folder-main_2'>
                <p
                    className='form-p form-w from-pointer folder-back'
                    onClick={handleFolderButtonClick}>
                    <RiArrowLeftLine /> Back
                </p>
                <div className='folder-tabel'>
                    <div className='folder-mt-30'>
                        <div className='folder-folder-title'>
                            <div className='folder-folder-icon'>
                                <RiBillLine className='folder-sideIcon-size' />
                                <h4 className='folder-main-title-icon'>
                                    {isFolderName}
                                </h4>
                            </div>
                            <p>
                                Use one of our suggested prebuilt templates or
                                build your own
                            </p>
                        </div>
                        <div className='relative folder-search-container'>
                            <Input
                                placeholder='What do you want to do?'
                                prefix={<RiSearch2Line />}
                                onChange={(e) => handlesearch(e)}
                                value={searchValue}
                            />
                        </div>
                        {quickactionfolderlistdata?.total > 0 ? (
                            <Table
                                columns={columns}
                                dataSource={quickactionfolderlistdata?.data}
                                // bordered
                                size='middle'
                                // pagination={{
                                //   pageSize: 4,
                                // }}
                                pagination={{
                                    current: currentPage,
                                    pageSize: quickactionfolderlistdata?.per_page,
                                    total: quickactionfolderlistdata?.total,
                                    showSizeChanger: false,
                                    onChange: handlePageChange,
                                }}
                                onChange={(pagination, filters, sorter) =>
                                    setSortedInfo(sorter)
                                }
                                className='mytable'
                            />
                        ) : (
                            <Card
                                bordered={false}
                                className='curve_card m-auto custom-scrollbar-curve'>
                                <img src={BookMark} alt='' />
                                <h1>No record found...</h1>
                            </Card>
                        )}
                    </div>
                </div>
            </div>

            {/* Second Div */}
            <div className='folder-main_2'>
                <div className='folder-tabel'>
                    <div className='folder-mt-30'>
                        <div className='folder-folder-title'>
                            <div className='folder-folder-icon'>
                                <RiFolderFill className='folder-sideIcon-size' />
                                <h4 className='folder-main-title-icon'>
                                    Other Prebuilt QuickActions
                                </h4>
                            </div>
                            <p>Use one of our prebuilt templates</p>
                        </div>
                        <Row gutter={[16, 24]}>
                            {quickactionfolder?.data?.length > 0 ? (
                                <>
                                    {quickactionfolder?.data &&
                                        quickactionfolder?.data.map(
                                            (item, index) => (
                                                <Col
                                                    className='gutter-row'
                                                    span={6}
                                                    key={`quick-action-view-${index}`}>
                                                    <div
                                                        className='build-text'
                                                        onClick={() =>
                                                            handleFolderClick(
                                                                item.id,
                                                                item.name
                                                            )
                                                        }>
                                                        <div className='build-container-main'>
                                                            <div className='build-div-third'>
                                                                <div className='build-top'></div>
                                                                <div className='build-div-info'>
                                                                    {item?.logo_url ||
                                                                    item?.company_name ? (
                                                                        <>
                                                                            {item.logo_url ? (
                                                                                <Tooltip
                                                                                    title={
                                                                                        item.company_name
                                                                                    }>
                                                                                    <img
                                                                                        src={
                                                                                            item.logo_url
                                                                                        }
                                                                                        className='logo_img'
                                                                                        alt='Company Logo'
                                                                                    />
                                                                                </Tooltip>
                                                                            ) : (
                                                                                <span className='logo_name'>
                                                                                    {
                                                                                        item.company_name
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    ) : null}
                                                                    {item?.is_restricted ===
                                                                        true && (
                                                                        <>
                                                                            <img
                                                                                src={
                                                                                    lock_icon
                                                                                }
                                                                                className='lock_icon'
                                                                            />
                                                                        </>
                                                                    )}
                                                                    <h1 className='wrap-text'>
                                                                        <Tooltip
                                                                            title={
                                                                                item.name
                                                                            }>
                                                                            {item
                                                                                .name
                                                                                .length >
                                                                            40
                                                                                ? item.name.substring(
                                                                                      0,
                                                                                      40
                                                                                  ) +
                                                                                  '...'
                                                                                : item.name}
                                                                        </Tooltip>
                                                                    </h1>
                                                                    <p>
                                                                        Total
                                                                        QuickActions
                                                                        <span>
                                                                            {' '}
                                                                            {
                                                                                item.total_quick_actions
                                                                            }
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )
                                        )}
                                </>
                            ) : null}
                        </Row>
                    </div>
                </div>
            </div>
            {isStandardOpen ? (
                <CopySave
                    StandardOverlay={StandardOverlay}
                    isStandardOpen={isStandardOpen}
                    selectedCopyItem={selectedCopyItem}
                />
            ) : null}
        </>
    );
};
export default Folder;
